












import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import { StoreDetails } from '@shared/types/stores';

import StoreCard from '~/components/Stores/StoreCard.vue';
import StoreCardSkeleton from '~/components/Stores/StoreCardSkeleton.vue';

export default defineComponent({
  name: 'StoresList',
  components: { StoreCardSkeleton, StoreCard },
  props: {
    stores: {
      type: Array as PropType<StoreDetails[]> | null,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const noStores = computed(() => props.stores?.length === 0);
    return {
      noStores,
    };
  },
});
